"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _UIRouterLink = _interopRequireDefault(require("ui-addon-react-router-dom/UIRouterLink"));

var _AbstractCallout = _interopRequireDefault(require("./AbstractCallout"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: flex;\n  align-items: stretch;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledUIRouterLink = (0, _styledComponents.default)(function (props) {
  return _react.default.createElement(_UIRouterLink.default, (0, _extends2.default)({}, props, {
    use: "unstyled"
  }));
}).withConfig({
  displayName: "RouterCallout__StyledUIRouterLink",
  componentId: "sc-1lj577w-0"
})(_templateObject());

var RouterCallout = function RouterCallout(props) {
  var className = props.className,
      onClick = props.onClick,
      to = props.to,
      rest = (0, _objectWithoutProperties2.default)(props, ["className", "onClick", "to"]);
  var computedClassName = (0, _classnames.default)('m-bottom-0', className);
  return _react.default.createElement(StyledUIRouterLink, {
    onClick: onClick,
    to: to
  }, _react.default.createElement(_AbstractCallout.default, (0, _extends2.default)({}, rest, {
    className: computedClassName
  })));
};

RouterCallout.propTypes = {
  className: _propTypes.default.string,
  onClick: _propTypes.default.func,
  to: _UIRouterLink.default.propTypes.to
};
var _default = RouterCallout;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/storefront/callouts/RouterCallout.js
// module id = 894
// module chunks = 209 210 211 212